import { render, staticRenderFns } from "./ErpCreditRuleBuilder.vue?vue&type=template&id=07874110&scoped=true"
import script from "./ErpCreditRuleBuilder.vue?vue&type=script&lang=ts"
export * from "./ErpCreditRuleBuilder.vue?vue&type=script&lang=ts"
import style0 from "./ErpCreditRuleBuilder.vue?vue&type=style&index=0&id=07874110&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07874110",
  null
  
)

export default component.exports